import {
  ArrowsIn,
  ArrowClockwise,
  ArrowCounterClockwise,
  ArrowsClockwise,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Barcode,
  BatteryFull,
  Bell,
  Book,
  Broadcast,
  Buildings,
  Calendar,
  CalendarBlank,
  CalendarCheck,
  Camera,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChartBar,
  ChartLine,
  ChatDots,
  Check,
  CheckCircle,
  Checks,
  CircleHalf,
  Clipboard,
  ClipboardText,
  Clock,
  ClockCounterClockwise,
  Cloud,
  CloudRain,
  CloudSun,
  Columns,
  Compass,
  Cpu,
  Cube,
  CurrencyDollar,
  CurrencyEur,
  Database,
  DeviceMobile,
  DotsSixVertical,
  DownloadSimple,
  Drop,
  Envelope,
  EnvelopeOpen,
  Eye,
  EyeSlash,
  FileArrowUp,
  FileText,
  Flask,
  FloppyDisk,
  Funnel,
  GasPump,
  Gauge,
  Gear,
  Globe,
  Hammer,
  Headphones,
  House,
  IdentificationBadge,
  IdentificationCard,
  Image,
  Info,
  Key,
  Leaf,
  Lightbulb,
  Lightning,
  List,
  ListChecks,
  Lock,
  MagnifyingGlass,
  MapPin,
  MapPinArea,
  MapTrifold,
  Minus,
  Mountains,
  Note,
  Package,
  PaperPlaneRight,
  PencilSimple,
  Percent,
  Phone,
  Plant,
  PlayCircle,
  Plus,
  Printer,
  Question,
  Ruler,
  Scales,
  ShieldCheck,
  ShoppingCart,
  SignOut,
  Snowflake,
  Spinner,
  Stack,
  Star,
  StarHalf,
  Stethoscope,
  Storefront,
  Sun,
  Syringe,
  Tag,
  Target,
  ThermometerSimple,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  ToggleLeft,
  ToggleRight,
  Toolbox,
  Tractor,
  Trash,
  UploadSimple,
  User,
  UserPlus,
  Users,
  VideoCamera,
  Warehouse,
  Warning,
  WifiHigh,
  Wind,
  Wrench,
  X,
  XCircle,
} from '@phosphor-icons/react'

export const icons = {
  APPLE_WHOLE: Plant,
  ARCHIVE_BOX: Package,
  ARROWS_CLOCKWISE: ArrowsClockwise,
  ARROWS_DOWN: ArrowDown,
  ARROWS_IN_SIMPLE: ArrowsIn,
  ARROW_CLOCKWISE: ArrowClockwise,
  ARROW_COUNTER_CLOCKWISE: ArrowCounterClockwise,
  ARROW_DOWN: ArrowDown,
  ARROW_LEFT: ArrowLeft,
  ARROW_RIGHT: ArrowRight,
  ARROW_UP: ArrowUp,
  BARCODE: Barcode,
  BARS: List,
  BATTERY_FULL: BatteryFull,
  BELL: Bell,
  BOLT: Lightning,
  BOOK: Book,
  BOX: Package,
  BOXES_STACKED: Stack,
  BOX_OPEN: Package,
  BROADCAST_TOWER: Broadcast,
  BUILDINGS: Buildings,
  BULLSEYE: Target,
  CALENDAR: Calendar,
  CALENDAR_ALT: Calendar,
  CALENDAR_CHECK: CalendarCheck,
  CALENDAR_DAY: CalendarBlank,
  CAMERA: Camera,
  CARET_DOWN: CaretDown,
  CARET_LEFT: CaretLeft,
  CARET_RIGHT: CaretRight,
  CARET_UP: CaretUp,
  CHART_BAR: ChartBar,
  CHART_LINE: ChartLine,
  CHART_COLUMN: ChartBar,
  CHAT_DOTS: ChatDots,
  CHECK: Check,
  CHECK_CIRCLE: CheckCircle,
  CHECK_DOUBLE: Checks,
  CIRCLE_CHECK: CheckCircle,
  CIRCLE_HALF: CircleHalf,
  CITY: Buildings,
  CLIPBOARD: Clipboard,
  CLIPBOARD_CHECK: ClipboardText,
  ENVELOPEOpen: EnvelopeOpen,
  TIMESCircle: XCircle,
  USERTag: User,
  CHEVRON_LEFT: CaretLeft,
  CHEVRON_RIGHT: CaretRight,
  CLIPBOARD_LIST: Clipboard,
  CLIPBOARD_TEXT: ClipboardText,
  CLOCK: Clock,
  CLOCK_COUNTER_CLOCKWISE: ClockCounterClockwise,
  CLOUD: Cloud,
  CLOUD_RAIN: CloudRain,
  CLOUD_SUN: CloudSun,
  COG: Gear,
  COGS: Gear,
  COLUMNS: Columns,
  COMMENT_DOTS: ChatDots,
  COMPASS: Compass,
  COMPRESS_ALT: ArrowsIn,
  CPU: Cpu,
  CUBE: Cube,
  CURRENCY_DOLLAR: CurrencyDollar,
  CURRENCY_EUR: CurrencyEur,
  DATABASE: Database,
  DEVICE_MOBILE: DeviceMobile,
  DOTS_SIX_VERTICAL: DotsSixVertical,
  DOWNLOAD_SIMPLE: DownloadSimple,
  DROP: Drop,
  DROPLET: Drop,
  EDIT: PencilSimple,
  ENVELOPE: Envelope,
  ENVELOPE_OPEN: EnvelopeOpen,
  ENVELOPE_OPEN_TEXT: Envelope,
  EURO_SIGN: CurrencyEur,
  EXCLAMATION_TRIANGLE: Warning,
  EYE: Eye,
  EYE_SLASH: EyeSlash,
  FILE_ARROW_UP: FileArrowUp,
  FILE_ALT: FileText,
  FILE_EXPORT: FileArrowUp,
  FILE_LINES: FileText,
  FILE_TEXT: FileText,
  FILTER: Funnel,
  FLASK: Flask,
  FLOPPY_DISK: FloppyDisk,
  FLOWER_LOTUS: Plant,
  FUNNEL: Funnel,
  GAS_PUMP: GasPump,
  GAUGE: Gauge,
  GAUGE_HIGH: Gauge,
  GEAR: Gear,
  GLOBE: Globe,
  GRIP_LINES: DotsSixVertical,
  HAMMER: Hammer,
  HEADPHONES: Headphones,
  HEADSET: Headphones,
  HISTORY: ClockCounterClockwise,
  HOME: House,
  HOUSE: House,
  ID_BADGE: IdentificationBadge,
  ID_CARD: IdentificationCard,
  IDENTIFICATION_BADGE: IdentificationBadge,
  IDENTIFICATION_CARD: IdentificationCard,
  IMAGE: Image,
  INFO: Info,
  INFO_CIRCLE: Info,
  KEY: Key,
  LAYER_GROUP: Stack,
  LEAF: Leaf,
  LIGHTBULB: Lightbulb,
  LIGHTNING: Lightning,
  LIST: List,
  LIST_CHECKS: ListChecks,
  LOCATION_DOT: MapPin,
  LOCK: Lock,
  MAGNIFYING_GLASS: MagnifyingGlass,
  MAIL_BULK: Envelope,
  MAP: MapTrifold,
  MAP_LOCATION_DOT: MapPinArea,
  MAP_MARKED_ALT: MapPin,
  MAP_MARKER_ALT: MapPin,
  MAP_PIN: MapPin,
  MAP_PIN_AREA: MapPinArea,
  MAP_TRIFOLD: MapTrifold,
  MICROCHIP: Cpu,
  MINUS: Minus,
  MOBILE_ALT: DeviceMobile,
  MOUND: Plant,
  MOUNTAIN: Mountains,
  MOUNTAINS: Mountains,
  NOTE: Note,
  NOTE_PENCIL: Note,
  NOTE_STICKY: Note,
  NOTES_MEDICAL: Note,
  PACKAGE: Package,
  PAPER_PLANE: PaperPlaneRight,
  PAPER_PLANE_RIGHT: PaperPlaneRight,
  PEN: PencilSimple,
  PEN_TO_SQUARE: PencilSimple,
  PENCIL_SIMPLE: PencilSimple,
  PERCENT: Percent,
  PHONE: Phone,
  PLANT: Plant,
  PLAY_CIRCLE: PlayCircle,
  PLUS: Plus,
  PRINTER: Printer,
  PRINT: Printer,
  QUESTION: Question,
  QUESTION_CIRCLE: Question,
  REDO: ArrowClockwise,
  ROTATE_LEFT: ArrowCounterClockwise,
  RULER: Ruler,
  RULER_COMBINED: Ruler,
  SATELLITE: Globe,
  SAVE: FloppyDisk,
  SCALES: Scales,
  SCREWDRIVER_WRENCH: Wrench,
  SEARCH: MagnifyingGlass,
  SEEDLING: Plant,
  SHAPES: Stack,
  SHIELD_ALT: ShieldCheck,
  SHIELD_CHECK: ShieldCheck,
  SHOPPING_CART: ShoppingCart,
  SIGN_OUT: SignOut,
  SIGN_OUT_ALT: SignOut,
  SNOWFLAKE: Snowflake,
  SPA: Plant,
  SPINNER: Spinner,
  STACK: Stack,
  STAR: Star,
  STAR_HALF_ALT: StarHalf,
  STETHOSCOPE: Stethoscope,
  STICKY_NOTE: Note,
  STORE: Storefront,
  STOREFRONT: Storefront,
  SUN: Sun,
  SYNC: ArrowsClockwise,
  SYNC_ALT: ArrowsClockwise,
  SYRINGE: Syringe,
  TACHOMETER_ALT: Gauge,
  TAG: Tag,
  TARGET: Target,
  TASKS: ListChecks,
  TEMPERATURE_HALF: ThermometerSimple,
  THERMOMETER_HALF: ThermometerSimple,
  THERMOMETER_SIMPLE: ThermometerSimple,
  THUMBS_DOWN: ThumbsDown,
  THUMBS_UP: ThumbsUp,
  TICKET: Ticket,
  TICKET_ALT: Ticket,
  TIMES: X,
  TIMES_CIRCLE: XCircle,
  TINT: Drop,
  TOGGLE_OFF: ToggleLeft,
  TOGGLE_ON: ToggleRight,
  TOOLS: Toolbox,
  TOOLBOX: Toolbox,
  TRACTOR: Tractor,
  TRASH: Trash,
  TRASH_ALT: Trash,
  TRIANGLE_EXCLAMATION: Warning,
  UNDO: ArrowCounterClockwise,
  UPLOAD_SIMPLE: UploadSimple,
  UPLOAD: UploadSimple,
  USER: User,
  USER_CHECK: User,
  USER_CIRCLE_CHECK: User,
  USER_CIRCLE_GEAR: User,
  USER_PLUS: UserPlus,
  USER_TAG: User,
  USERS: Users,
  VIDEO: VideoCamera,
  VIDEO_CAMERA: VideoCamera,
  WAREHOUSE: Warehouse,
  WARNING: Warning,
  WATER: Drop,
  WEIGHT_HANGING: Scales,
  WHEAT_AWN: Plant,
  WIFI: WifiHigh,
  WIFI_HIGH: WifiHigh,
  WIND: Wind,
  WRENCH: Wrench,
  X: X,
  X_CIRCLE: XCircle,
}

const ICON = Object.keys(icons).reduce((acc, key) => {
  acc[key] = key
  return acc
}, {})

Object.freeze(ICON)

export { ICON }
